import React, { FC, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import Pages from "../constants/pages";

const AppLazy = lazy(() => import("../routes/app"));
const PublicLazy = lazy(() => import("../routes/public"));

const RouteLayout: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="app/*"
          element={
            <ProtectedRoute>
              <Suspense fallback={<></>}>
                <AppLazy />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <Suspense fallback={<></>}>
              <PublicLazy />
            </Suspense>
          }
        />
        <Route path="" element={<Navigate to={`/app/${Pages.DASHBOARD}`} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouteLayout;
